import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../../core/table/table.component';
import { ColumnComponent } from '../../../../../core/table/column.component';
import { TabPanelComponent } from '../../../../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../../../../core/panels/tab-panel/tab.component';
import { PolicyAttributesComponent } from '../../../../policy-details/policy-attributes.component';
import { RiskUnitClassCodeComponent } from '../risk-unit-class-code.component';
import { PolicyCoveragesComponent } from '../../coverages/coverages.component';
import { RiskUnitItemDetailComponent } from './risk-unit-item-detail.component';

@Component({
  selector: 'app-risk-unit-items',
  imports: [
    TableComponent,
    ColumnComponent,
    TabPanelComponent,
    TabComponent,
    PolicyAttributesComponent,
    RiskUnitClassCodeComponent,
    PolicyCoveragesComponent,
    RiskUnitItemDetailComponent,
  ],
  template: `<app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [expandable]="true"
    dataKey="id"
    recordLabel="item"
    [globalFilterFields]="[
      'details.itemId',
      'details.type',
      'details.buildingId',
      'details.isPrimary',
      'details.description',
    ]"
  >
    <app-column name="details.itemId" label="ID" labelCase="none" width="20%" />
    <app-column name="details.type" label="Type" width="20%" />
    <app-column
      name="details.buildingId"
      label="Building ID"
      labelCase="none"
      width="20%"
    />
    <app-column name="details.isPrimary" label="Is Primary" width="20%" />
    <app-column name="details.description" label="Description" width="20%" />

    <ng-template #expand let-data>
      <div class="tw-flex tw-gap-8">
        <div class="tw-basis-full">
          <app-tab-panel>
            <app-tab label="Detail">
              <ng-template #content>
                <app-risk-unit-item-detail [dataSource]="data.details" />
              </ng-template>
            </app-tab>
            <app-tab label="Attributes" [count]="data.itemAttributes.length">
              <ng-template #content>
                <app-policy-attributes
                  [dataSource]="data.itemAttributes"
                  [showEmpty]="true"
                  [source]="lineOfBusiness"
                  layout="policy"
                  theme="Dark"
                />
              </ng-template>
            </app-tab>
            <app-tab
              label="Item Class Codes"
              [count]="data.itemClassCodes.length"
            >
              <ng-template #content>
                <app-risk-unit-class-code
                  [dataSource]="data.itemClassCodes"
                  theme="Dark"
                />
              </ng-template>
            </app-tab>
            <app-tab label="Item Coverages" [count]="data.itemCoverages.length">
              <ng-template #content>
                <app-coverages
                  [dataSource]="data.itemCoverages"
                  [lineOfBusiness]="lineOfBusiness"
                />
              </ng-template>
            </app-tab>
          </app-tab-panel>
        </div>
      </div>
    </ng-template>
  </app-table>`,
  styles: [],
})
export class RiskUnitItemsComponent {
  @Input() dataSource: any;
  @Input() lineOfBusiness: string;
}
